import React, { useEffect, useState } from "react";

export default ({ questionCount }) => {
  const [questions, setQuestion] = useState({
    id: 1,
    start: "Please rate where you stand on your journey for the best possible",
    middle: "career",
    end: ".",
  });
  useEffect(() => {
    if (questionCount >= 1) {
      switch (questionCount) {
        case 2:
          setQuestion({
            id: 2,
            start: "Where would you rate your",
            middle: "social",
            end: "life as a whole?",
          });
          break;
        case 3:
          setQuestion({
            id: 3,
            start:
              "Please rate how well you are living your best possible life,",
            middle: "Financially",
            end: ".",
          });
          break;
        case 4:
          setQuestion({
            id: 4,
            start: "Where are you with attaining the best possible",
            middle: "physical",
            end: "consdition for yourself?",
          });
          break;
        case 5:
          setQuestion({
            id: 5,
            start: "How would you rate your interection with your",
            middle: "community",
            end: "?",
          });
          break;

        default:
          setQuestion({
            start:
              "Please rate where you stand on your journey for the best possible",
            middle: "career",
            end: ".",
          });
      }
    }
  }, [questionCount]);
  return (
    <>
      <div className="assessmentQuestionContainer">
        <p className="questionStaticHeading">
          On a Scale of 1-10 (10 being the best)
        </p>
        <p className="assessmentQuestion">
          {questions?.start}
          <span className="assessmentHighLight"> {questions?.middle} </span>
          {questions?.end}
        </p>
      </div>
    </>
  );
};
